/**
 * 裁剪头像上传
 */
import React, { Component } from 'react';
import axios from 'axios';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import Cropper from 'react-easy-crop';
import Button from '../button';
import Icon from '../icon';
import Modal from '../modal';
import message from '../message';
import Upload from '../upload';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import defaultLocale from '../locale-provider/default';
import ConfigContext from '../config-provider/ConfigContext';
const Dragger = Upload.Dragger;
const { round } = Math;
const ButtonGroup = Button.Group;
const maxZoomVal = 3;
const zoomStep = 0.5;
function rotateFlag(rotate) {
    return (rotate / 90) % 2 !== 0;
}
let Avatarlocale = defaultLocale.imageCrop;
export default class AvatarUploader extends Component {
    constructor(props, context) {
        super(props, context);
        this.zoomImage = (type) => {
            let { zoom } = this.state;
            const { imageStyle: { width, height }, cropSize } = this.state;
            const minZoomVal = cropSize / Math.min(width, height);
            switch (type) {
                case 'add': {
                    zoom = (zoom + zoomStep) >= maxZoomVal ? maxZoomVal : (zoom + zoomStep);
                    this.setState({ zoom });
                    break;
                }
                case 'sub': {
                    zoom = (zoom - zoomStep) <= minZoomVal ? minZoomVal : (zoom - zoomStep);
                    this.setState({ zoom });
                    break;
                }
                case 'init':
                    {
                        const x = (width - cropSize) / 2 / width;
                        const y = (height - cropSize) / 2 / width;
                        this.setState({ zoom: 1, rotate: 0, crop: { x, y } });
                    }
                    break;
                default:
                    break;
            }
        };
        this.handleOk = () => {
            const { x, y, size, rotate, file, imageStyle: { width, height }, img: { naturalWidth } } = this.state;
            const { uploadUrl, uploadFaild, uploadError, handleUpload, axiosConfig } = this.props;
            const flag = rotateFlag(rotate);
            const scale = naturalWidth / width;
            const startX = flag ? x - ((width - height) / 2) : x;
            const startY = flag ? y + ((width - height) / 2) : y;
            const QsData = {
                rotate,
                startX: round(startX * scale),
                startY: round(startY * scale),
                endX: round(size * scale),
                endY: round(size * scale),
            };
            const qs = JSON.stringify(QsData);
            const data = new FormData();
            data.append('file', file);
            this.setState({ submitting: true });
            if (uploadUrl) {
                let config;
                if (axiosConfig) {
                    config = axiosConfig;
                }
                axios.post(`${uploadUrl}?${qs}`, data, config)
                    .then((res) => {
                    if (res.success) {
                        this.uploadOk(res);
                    }
                    else {
                        message.error(Avatarlocale.avatarUploadError);
                        this.setState({ submitting: false });
                        if (uploadFaild) {
                            uploadFaild();
                        }
                    }
                })
                    .catch((error) => {
                    message.error(`${Avatarlocale.avatarServerError}${error}`);
                    this.setState({ submitting: false });
                    if (uploadError) {
                        uploadError(error);
                    }
                });
            }
            if (handleUpload) {
                QsData.file = file;
                handleUpload(QsData);
            }
        };
        this.handleCancel = () => {
            this.close();
        };
        const { rectSize } = props;
        this.state = {
            submitting: false,
            img: null,
            file: '',
            imageStyle: { width: 0, height: 0 },
            crop: {
                x: 0,
                y: 0,
            },
            rotate: 0,
            zoom: 1,
            cropSize: rectSize,
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    close() {
        const { onClose } = this.props;
        this.setState({
            img: null,
        });
        if (onClose) {
            onClose(false);
        }
    }
    uploadOk(res) {
        const { onUploadOk } = this.props;
        this.setState({
            img: null,
            submitting: false,
        }, () => {
            if (onUploadOk) {
                onUploadOk(res);
            }
        });
    }
    initImageSize(img, rotate = 0) {
        const { editorWidth, editorHeight, rectSize } = this.props;
        const { naturalWidth, naturalHeight } = img;
        const flag = rotateFlag(rotate);
        let width = flag ? naturalHeight : naturalWidth;
        let height = flag ? naturalWidth : naturalHeight;
        if (width < rectSize || height < rectSize) {
            if (width > height) {
                width = (width / height) * rectSize;
                height = rectSize;
            }
            else {
                height = (height / width) * rectSize;
                width = rectSize;
            }
        }
        else if (width > editorWidth || height > editorHeight) {
            if (width / editorWidth > height / editorHeight) {
                height = (height / width) * editorWidth;
                width = editorWidth;
            }
            else {
                width = (width / height) * editorHeight;
                height = editorHeight;
            }
        }
        if (flag) {
            const tmp = width;
            width = height;
            height = tmp;
        }
        const size = Math.min(rectSize, width, height);
        this.setState({
            img,
            imageStyle: {
                width,
                height,
                top: (editorHeight - height) / 2,
                left: (editorWidth - width) / 2,
                transform: `rotate(${rotate}deg)`,
            },
            size,
            cropSize: size,
            x: (width - size) / 2,
            y: (height - size) / 2,
            rotate,
        });
    }
    onComplete(imgState) {
        const { zoom, imageStyle: { width, height }, cropSize } = this.state;
        let { x, y } = imgState;
        x = Math.ceil(x * width / 100);
        y = Math.ceil(y * height / 100);
        const imageState = { x, y, size: cropSize / zoom };
        const { cropComplete } = this.props;
        this.setState(imageState);
        if (cropComplete) {
            cropComplete(imageState);
        }
    }
    loadImage(src) {
        if (typeof window !== 'undefined') {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                this.initImageSize(img);
            };
        }
    }
    getPreviewProps(previewSize) {
        const { size, x, y, img: { src }, rotate, imageStyle: { width, height } } = this.state;
        const previewScale = previewSize / size;
        let radius = (rotate % 360) / 90;
        let px = -x;
        let py = -y;
        if (radius < 0)
            radius += 4;
        if (radius === 1) {
            py = ((x + ((height - width) / 2)) - height) + size;
            px = ((height - width) / 2) - y;
        }
        else if (radius === 2) {
            px = (x - width) + size;
            py = (y - height) + size;
        }
        else if (radius === 3) {
            px = ((y + ((width - height) / 2)) - width) + size;
            py = ((width - height) / 2) - x;
        }
        return {
            style: {
                width: previewSize,
                height: previewSize,
                backgroundImage: `url('${src}')`,
                backgroundSize: `${width * previewScale}px ${height * previewScale}px`,
                backgroundPosition: `${px * previewScale}px ${py * previewScale}px`,
                transform: `rotate(${rotate}deg)`,
            },
        };
    }
    renderPreviewItem(previewSizeList) {
        const { prefixCls: customizePrefixCls } = this.props;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('avatar-crop-edit', customizePrefixCls);
        return previewSizeList.map((itemSize) => (React.createElement("div", { key: itemSize, className: `${prefixCls}-preview-item` },
            React.createElement("i", Object.assign({}, this.getPreviewProps(itemSize))),
            React.createElement("p", null, `${itemSize}＊${itemSize}`))));
    }
    renderEditor(props) {
        const { img, rotate, zoom, crop, imageStyle: { width, height }, cropSize } = this.state;
        const { prefixCls: customizePrefixCls, previewList, editorWidth, editorHeight, previewTitle, reloadTitle } = this.props;
        const { getPrefixCls } = this.context;
        const { src } = img;
        const style = { width: editorWidth, height: editorHeight, position: 'relative' };
        const minZoomVal = cropSize / Math.min(width, height);
        const isMinZoom = zoom === minZoomVal;
        const isMaxZoom = zoom === maxZoomVal;
        const prefixCls = getPrefixCls('avatar-crop-edit', customizePrefixCls);
        const previewTitleFlag = isString(previewTitle) || React.isValidElement(previewTitle);
        const renderPreviewTitle = () => {
            if (!previewTitleFlag || !previewTitle)
                return null;
            if (isString(previewTitle)) {
                return (React.createElement("h5", { className: `${prefixCls}-preview-title` },
                    React.createElement("span", null, previewTitle)));
            }
            return previewTitle;
        };
        return (React.createElement("div", null,
            React.createElement("div", { className: `${prefixCls}-wraper` },
                React.createElement("div", { className: `${prefixCls}-edit`, style: style },
                    React.createElement(Cropper, { image: src, crop: crop, showGrid: false, cropSize: { width: cropSize, height: cropSize }, zoom: zoom, minZoom: minZoomVal, rotation: rotate, aspect: 1 / 1, onCropChange: (crop) => this.setState({ crop }), onCropComplete: ({ x, y }) => this.onComplete({ x, y, cropSize }), onZoomChange: (zoom) => {
                            this.setState({ zoom });
                        } })),
                React.createElement("div", { className: `${prefixCls}-preview` },
                    renderPreviewTitle(),
                    this.renderPreviewItem(previewList))),
            React.createElement("div", { className: `${prefixCls}-button`, style: { width: editorWidth } },
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { funcType: "raised", icon: "zoom_in", disabled: isMaxZoom, onClick: () => this.zoomImage('add') }),
                    React.createElement(Button, { funcType: "raised", icon: "zoom_out", disabled: isMinZoom, onClick: () => this.zoomImage('sub') })),
                React.createElement(Button, { funcType: "raised", icon: "play_90", onClick: () => this.setState({ rotate: (rotate + 90) >= 360 ? 0 : (rotate + 90) }) }),
                React.createElement(Button, { funcType: "raised", onClick: () => this.zoomImage('init') }, "1:1"),
                React.createElement(Upload, Object.assign({}, props),
                    React.createElement(Button, { funcType: "raised", icon: "file_upload" },
                        React.createElement("span", null, reloadTitle || Avatarlocale.reUpload))))));
    }
    getUploadProps() {
        const { limit: { size: limitSize, type }, uploadProps } = this.props;
        const typeLimit = type.split(',').map((item) => `image/${item}`).join(',');
        return {
            multiple: false,
            name: 'file',
            accept: typeLimit,
            headers: {
                Authorization: `bearer`,
            },
            showUploadList: false,
            ...uploadProps,
            beforeUpload: (file) => {
                const { size } = file;
                if (size > limitSize * 1024) {
                    message.warning(Avatarlocale.imageTooLarge);
                    return false;
                }
                this.setState({ file });
                const windowURL = window.URL || window.webkitURL;
                if (windowURL && windowURL.createObjectURL) {
                    this.loadImage(windowURL.createObjectURL(file));
                    return false;
                }
                return false;
            },
            onChange: ({ file }) => {
                const { status, response } = file;
                if (status === 'done') {
                    this.loadImage(response);
                }
                else if (status === 'error') {
                    message.error(Avatarlocale.imageUploadError);
                }
            },
        };
    }
    renderContainer() {
        const { prefixCls: customizePrefixCls, limit: { size: limitSize, type } } = this.props;
        const { img } = this.state;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('avatar-crop', customizePrefixCls);
        const props = this.getUploadProps();
        return img ? (this.renderEditor(props)) : (React.createElement(Dragger, Object.assign({ className: `${prefixCls}-dragger` }, props),
            React.createElement(Icon, { type: "inbox" }),
            React.createElement("h3", { className: `${prefixCls}-dragger-text` },
                React.createElement("span", null, Avatarlocale.imageDragHere)),
            React.createElement("h4", { className: `${prefixCls}-dragger-hint` },
                React.createElement("span", null, `${Avatarlocale.pleaseUpload}${limitSize / 1024}M,${Avatarlocale.uploadType}${type}${Avatarlocale.picture}`))));
    }
    render() {
        const { visible, modalProps, title } = this.props;
        const { img, submitting } = this.state;
        const cancelButtonProps = { disabled: submitting, funcType: 'raised' };
        const okButtonProps = { funcType: 'raised', type: 'primary', disabled: !img, loading: submitting };
        return (React.createElement(LocaleReceiver, { componentName: "imageCrop", defaultLocale: defaultLocale.imageCrop }, (locale) => {
            Avatarlocale = locale || defaultLocale.imageCrop;
            return (React.createElement(Modal, Object.assign({ title: title || React.createElement("span", null, Avatarlocale.changeAvatar), className: "avatar-modal", visible: visible, width: 600, closable: true, maskClosable: false, onOk: this.handleOk, onCancel: this.handleCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps }, modalProps), this.renderContainer()));
        }));
    }
}
AvatarUploader.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onUploadOk: PropTypes.func,
    limit: PropTypes.object,
    uploadUrl: PropTypes.string,
    previewList: PropTypes.array,
    editorWidth: PropTypes.number,
    editorHeight: PropTypes.number,
    rectSize: PropTypes.number,
    prefixCls: PropTypes.string,
    handleUpload: PropTypes.func,
    axiosConfig: PropTypes.object,
    cropComplete: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    previewTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    reloadTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    uploadProps: PropTypes.object,
    modalProps: PropTypes.object,
    reloadText: PropTypes.func,
    uploadFaild: PropTypes.func,
    uploadError: PropTypes.func,
};
AvatarUploader.defaultProps = {
    limit: {
        type: 'jpeg,png,jpg',
        size: 1024,
    },
    previewList: [80, 48, 34],
    editorWidth: 380,
    editorHeight: 380,
    rectSize: 280,
};
